import template from './class-designer-editor.html';
import controller from './class-designer-editor.controller';

export default {
	template,
	controller,
	bindings: {
		ctrl:     '<',
		tab:      '<',
		tabIndex: '<',
	},
};
